import { render, staticRenderFns } from "./aspProgram.vue?vue&type=template&id=a32e8270&"
import script from "./aspProgram.vue?vue&type=script&lang=ts&"
export * from "./aspProgram.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports